import { CourseDetails } from '@lx/quote-tool/lite/shared/types';

export type OnlineCourseDetails = CourseDetails & {
  shortName?: string;
  benefits?: string[];
};
